import { format } from 'date-fns/format';
import {
	enUS,
	fr,
	de,
	es,
	zhCN,
	ar,
	ja,
	ru,
	zhTW,
	ptBR,
	pt,
	it,
	ko,
	tr,
	el,
} from 'date-fns/locale';

const fnsLocaleMap = {
	en: enUS,
	'en-US': enUS,
	fr: fr,
	de: de,
	ar: ar,
	jp: ja,
	ja: ja,
	ru: ru,
	br: ptBR,
	it: it,
	kr: ko,
	ko: ko,
	tr: tr,
	gr: el,
	el: el,
	pt: pt,
	es: es,
	'es-es': es,
	'pt-br': pt,
	zh_hant: zhTW,
	'zh-tw': zhTW,
	'zh-cn': zhCN,
	zh: zhCN,
};
export const formatDate = (locale: string, date: Date) =>
	format(date, 'P', { locale: fnsLocaleMap[locale] || enUS });
export const formatDay = (locale: string, date: Date) =>
	format(date, 'd', { locale: fnsLocaleMap[locale] || enUS });
export const formatLongDate = (locale: string, date: Date) =>
	format(date, 'MMM d, yyyy', { locale: fnsLocaleMap[locale] || enUS });
export const formatMonthYear = (locale: string, date: Date) =>
	format(date, 'MMMM yyyy', { locale: fnsLocaleMap[locale] || enUS });
export const formatShortWeekday = (locale: string, date: Date) =>
	format(date, locale === 'en' ? 'eeeee' : 'eeeeee', { locale: fnsLocaleMap[locale] || enUS });
export const formatWeekday = (locale: string, date: Date) =>
	format(date, 'EEEE', { locale: fnsLocaleMap[locale] || enUS });
